import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=cadca522&scoped=true"
import script from "./purchased.vue?vue&type=script&lang=js"
export * from "./purchased.vue?vue&type=script&lang=js"
import style0 from "./purchased.vue?vue&type=style&index=0&id=cadca522&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadca522",
  null
  
)

export default component.exports